import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const renders = [
  {
    src: 'https://readdy.ai/api/search-image?query=3D%20render%20luxury%20interior%20room%20visualization%20photorealistic%20modern%20living%20space%20elegant%20furniture%20warm%20lighting%20architecture%20design%20high%20quality&width=420&height=300&seq=evco_3dr001&orientation=landscape',
    alt: 'Rendu 3D salon de luxe',
    tag: 'Rendu 3D',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=custom%203D%20printed%20figurine%20personnalisee%20couple%20wedding%20portrait%20resin%20miniature%20statue%20detailed%20craftsmanship%20white%20simple%20background%20professional%20product%20photography&width=420&height=480&seq=evco_fig_perso001&orientation=portrait',
    alt: 'Figurine personnalisée couple',
    tag: 'Figurine',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=personalized%203D%20printed%20figurine%20family%20custom%20resin%20miniature%20portrait%20sculpture%20people%20white%20neutral%20background%20studio%20lighting%20detailed%20high%20quality%20product%20photography&width=420&height=480&seq=evco_fig_perso002&orientation=portrait',
    alt: 'Figurine personnalisée famille',
    tag: 'Figurine',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/77439906415ee6c0b7449726f7990fa0.jpeg',
    alt: 'Figurine couple mariage',
    tag: 'Figurine',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/4db849ce555041e83c7486d626c8d5ff.jpeg',
    alt: 'Rendu 3D chambre',
    tag: 'Rendu 3D',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/318bdeeab89f85cfbc4ee0175d2a5ade.jpeg',
    alt: 'Lettres décoratives 3D',
    tag: 'Objet Déco',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=3D%20render%20modern%20office%20interior%20design%20visualization%20photorealistic%20professional%20workspace%20Abidjan%20Africa%20elegant%20contemporary&width=420&height=280&seq=evco_3dr003&orientation=landscape',
    alt: 'Rendu 3D bureau',
    tag: 'Rendu 3D',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/cabe8cd83d2153ad98eefbadbd77d9bb.jpeg',
    alt: 'Goodies entreprise',
    tag: 'Goodies',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/c274fe5b9a1d261d4857871d001a58e8.jpeg',
    alt: 'Maquette architecturale 3D',
    tag: 'Maquette',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/151812c44df937be8ecc88de7689f65f.jpeg',
    alt: 'Trophée personnalisé',
    tag: 'Trophée',
  },
  {
    src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/84732d1d940c27c667f7f93504bbe6bb.jpeg',
    alt: 'Rendu 3D salon africain contemporain',
    tag: 'Rendu 3D',
  },
];

const Creation3DGallery = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-brand-beige py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">
              Portfolio
            </span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">
            Rendus &amp; Objets Imprimés
          </h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            Un aperçu de notre univers créatif — entre visualisation numérique et fabrication physique.
          </p>
        </div>

        <div
          ref={ref}
          className={`columns-2 md:columns-3 gap-4 transition-all duration-700 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {renders.map((item, idx) => (
            <div
              key={item.alt}
              className="break-inside-avoid mb-4 relative group overflow-hidden rounded-xl cursor-pointer"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <img
                src={item.src}
                alt={item.alt}
                className="w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <span
                  className="inline-block px-2 py-0.5 rounded-full text-white text-xs font-medium mb-1 self-start"
                  style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
                >
                  {item.tag}
                </span>
                <p className="text-white text-sm font-medium">{item.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Creation3DGallery;
